<template>
<div>
    <v-card style="width:100%;height:90px" class="secondary">
     <v-layout row wrap style="height:40px;">
      <v-flex xs10 style="padding:10px;" >
            <div class="title" style="color:white">DTH Booking Statement</div>
      </v-flex>
      <v-flex xs2>
      </v-flex>
    </v-layout>
     <v-layout row wrap style="height:40px;">
      <v-flex xs12 style="padding-top:8px" >
         <v-btn class="success searchbtn" @click="fetchstatement"> Search</v-btn>
    <v-menu
        :close-on-content-click="false"
        v-model="menu2"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date2" readonly class="search" placeholder="To Date" >
        <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
      </v-menu>
    <v-menu
        :close-on-content-click="false"
        v-model="menu1"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date1" readonly class="search" placeholder="From Date" >
        <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
      </v-menu>
      </v-flex>
<v-layout row wrap>
    <v-spacer></v-spacer>
  </v-layout>
    </v-layout>
</v-card>

      <v-data-table
      :headers="headers"
      :items="statementlist"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.date }}</td>
        <td >{{ props.item.name }}</td>
        <td >{{ props.item.operator }}</td>
        <td >{{ props.item.plan }}</td>
        <td >{{ props.item.description }}</td>
        <td >{{ props.item.amount }}</td>
        <td >{{ props.item.status }}</td>
        <td >{{ props.item.mobile }}</td>
        <td >{{ props.item.address }}</td>
        <td >{{ props.item.pincode }}</td>
        <td >{{ props.item.txtid }}</td>
      </template>
    </v-data-table>


  <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>
</div>
</template>


<script>
export default {
   data(){
      return{
            headers: [
                { text: 'Date', value: 'date',align: 'left' },
                { text: 'Name', value: 'name' },
                { text: 'Operator', value: 'operator' },
                { text: 'Plan', value: 'plan' },
                { text: 'Description', value: 'description' },
                { text: 'Amount', value: 'amount' },
                { text: 'Status', value: 'status' },
                { text: 'Mobile', value: 'mobile' },
                { text: 'Address', value: 'address' },
                { text: 'Pincode', value: 'pincode' },
                { text: 'TXID', value: 'txid' },
            ],
            dialog:false,
            statementlist:[],
            modal:false,
            date1:'',
            menu1:false,
            date2:'',
            menu2:false
      }
   },
   computed:{
      user(){
         return this.$store.getters.user;
      }
   },
   methods:{
     notification(type,message){
        this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
        })
      },
      pushstatement(value){
         let vm = this;
            vm.offerlist = []
            let key = 1;
            for(let i =0;i<value.length;i++){
               vm.offerlist.push({
                  key:key,
                  name:value[i].Service,
                  offer:value[i].Offer
               })
               key++;
            }

      },
      fetchstatement(){
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'Source':'json'
           }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                  url:"DthBooking_Statement",
                  data:doc,
            }).then(function (res) {
                  vm.dialog = false;
                  vm.pushstatement(res.data)
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;
            })
   }
   },
   mounted(){
      let vm = this;
      vm.fetchstatement()
   }
}
</script>

<style scoped>
.search{
   width:150px;
   float: right;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}
.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}

</style>

